<div class="MainBg IIFL_New_Design pr-0">
  <div class="MainInnerFormWithoutFlex">
    <div class="FormTemplate w-100" style="padding-right: 200px;">

      <div class="pg-status-card">

        <div class="pg-status-icon"
          [ngClass]="{
            'pg-icon-success': isSuccess,
            'pg-icon-failed': isFailed,
            'pg-icon-neutral': !isSuccess && !isFailed
          }">
          <span *ngIf="isSuccess">&#10003;</span>
          <span *ngIf="isFailed">&#10005;</span>
          <span *ngIf="!isSuccess && !isFailed">!</span>
        </div>

        <h2 class="pg-status-title"
          [ngClass]="{ 'ColorGreen': isSuccess, 'ColorRed': isFailed }">
          <ng-container *ngIf="isSuccess">Payment Successful</ng-container>
          <ng-container *ngIf="isFailed">Payment Failed</ng-container>
          <ng-container *ngIf="!isSuccess && !isFailed">Payment Status</ng-container>
        </h2>

        <p class="pg-status-message">{{ message }}</p>

        <div class="pg-status-detail">
          <span class="pg-detail-label">Transaction ID</span>
          <span class="pg-detail-value">{{ txnId }}</span>
        </div>

        <div class="pg-status-detail">
          <span class="pg-detail-label">Status Code</span>
          <span class="pg-detail-value">{{ statusCode }}</span>
        </div>

        <a href="/dashboard" class="CursorPointer CommonSubmitButton pg-back-btn">Go to Dashboard</a>

      </div>

    </div>
  </div>
</div>
